import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { createRef, PureComponent } from 'react';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import ButtonBlock from '../ButtonBlock';
import css from './ShopSlider.module.scss';
import Image from '../Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MOBILE_WIDTH = 767;

var ShopSlider = /*#__PURE__*/function (_PureComponent) {
  _inherits(ShopSlider, _PureComponent);

  var _super = _createSuper(ShopSlider);

  function ShopSlider(props) {
    var _this;

    _classCallCheck(this, ShopSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      window.clearTimeout(_this.interval);
      _this.interval = setTimeout(_this.onScrollEnd, 50);
    });

    _defineProperty(_assertThisInitialized(_this), "onScrollEnd", function () {
      var closest = _this.getClosestIndex();

      var index = _this.state.index;

      if (index !== closest) {
        _this.goTo(closest);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getClosestIndex", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          total = _assertThisInitialize.total;

      var productEl = _this.scroller.current;

      if (!productEl) {
        return -1;
      }

      var scrollWidth = productEl.scrollWidth || 0;
      var scrollLeft = productEl.scrollLeft || 0;
      var offsetWidth = productEl.offsetWidth || 0;

      if (scrollWidth - offsetWidth <= scrollLeft) {
        return total - 1;
      }

      var firstPassed = Array(total).fill().findIndex(function (product, index) {
        var ref = _this.productRefs[index].current;
        return ref && ref.offsetLeft && ref.offsetLeft - 1 > scrollLeft;
      });
      var productIndex = firstPassed - 1;
      return productIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "goTo", function (index) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          total = _assertThisInitialize2.total;

      var isMobile = windowWidth() <= MOBILE_WIDTH;

      if (isMobile) {
        return false;
      }

      if (index < 0 || index === total) {
        return false;
      }

      var scroller = _this.scroller.current;
      var target = _this.productRefs[index].current;

      if (!scroller || !target) {
        return false;
      }

      var scrollTo = target && target.offsetLeft ? target.offsetLeft : 0;

      _this.scrollTo(scroller, scrollTo);

      _this.setState({
        index: index
      });

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (scroller, scrollLeft) {
      scroller.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "canGoLeft", function () {
      var index = _this.state.index;
      return index !== 0;
    });

    _defineProperty(_assertThisInitialized(_this), "canGoRight", function () {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          total = _assertThisInitialize3.total;

      var index = _this.state.index;

      if (index === total - 1) {
        return false;
      }

      var firstProduct = _this.productRefs[0].current;

      if (!firstProduct) {
        return index === 0;
      }

      var productWidth = firstProduct.offsetWidth || 0;
      var numCanShow = Math.floor(windowWidth() / productWidth);

      if (total - index <= numCanShow) {
        return false;
      }

      return true;
    });

    var products = _this.props.products;
    _this.scroller = /*#__PURE__*/createRef();
    _this.productRefs = [];
    _this.total = products.length;

    for (var idx = 0; idx < _this.total; idx += 1) {
      _this.productRefs.push( /*#__PURE__*/createRef());
    }

    _this.interval = {};
    _this.state = {
      index: 0
    };
    return _this;
  }

  _createClass(ShopSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var productEl = this.scroller.current;

      if (productEl) {
        productEl.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.interval);
      var productEl = this.scroller.current;

      if (productEl) {
        productEl.removeEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var products = this.props.products;
      var index = this.state.index;
      return /*#__PURE__*/_jsxs("div", {
        className: css.root,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.products,
          ref: this.scroller,
          children: products.map(function (product, productIndex) {
            return /*#__PURE__*/_jsxs("a", {
              className: css.productWrap,
              href: product.url,
              ref: _this2.productRefs[productIndex],
              children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                className: css.product
              }, product)), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
                className: css.hoverImage
              }, product), {}, {
                src: product.hoverSrc
              })), /*#__PURE__*/_jsx("p", {
                className: css.insetCaption,
                children: product.alt
              })]
            }, product.src);
          })
        }), /*#__PURE__*/_jsx(ButtonBlock, {
          disabled: !this.canGoLeft(),
          height: "100%",
          left: true,
          onClick: function onClick() {
            return _this2.goTo(index - 1);
          }
        }), /*#__PURE__*/_jsx(ButtonBlock, {
          disabled: !this.canGoRight(),
          height: "100%",
          left: false,
          onClick: function onClick() {
            return _this2.goTo(index + 1);
          }
        })]
      });
    }
  }]);

  return ShopSlider;
}(PureComponent);

ShopSlider.defaultProps = {};
ShopSlider.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default ShopSlider;